import DonutChart from './DonutChart';

export default DonutChart;

export type { DonutChartSize, IDonutChartProps, IDonutSegment } from './DonutChart';
